window.Noty = require('noty');

window.noty = function (text, type) {
    new Noty({
        text: text,
        type: type || 'alert', //alert, success, warning, error
        theme: 'relax',
    }).show();
}